// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__180cp","niraLogo":"Logo_niraLogo__2qdn7"};